import * as React from 'react';

const LogoutIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path
      fill={fillColor}
      d="M11.438 11.188a.617.617 0 0 1-.188-.454c0-.177.063-.324.188-.442l1.666-1.667H6.438a.603.603 0 0 1-.446-.18.61.61 0 0 1-.18-.449.61.61 0 0 1 .625-.621h6.625l-1.687-1.688a.577.577 0 0 1-.167-.425c0-.173.064-.323.192-.448a.577.577 0 0 1 .44-.189c.176 0 .327.063.452.188l2.77 2.77c.07.07.119.14.146.211a.625.625 0 0 1 0 .456.634.634 0 0 1-.146.208l-2.75 2.75a.578.578 0 0 1-.427.167.611.611 0 0 1-.447-.188ZM1.75 15.5a1.2 1.2 0 0 1-.875-.375A1.2 1.2 0 0 1 .5 14.25V1.75A1.2 1.2 0 0 1 .875.875 1.2 1.2 0 0 1 1.75.5h5.438c.177 0 .325.06.445.18.12.121.18.27.18.449a.61.61 0 0 1-.625.621H1.75v12.5h5.438c.177 0 .325.06.445.18.12.121.18.27.18.449a.61.61 0 0 1-.625.621H1.75Z"
    />
  </svg>
);

export default LogoutIcon;
